module.exports = "import { Icon } from \"../../lib\";\nimport React from \"react\";\n\nexport default () => (<Icon />);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Icon/demo/simpleUse.js
// module id = 134
// module chunks = 0